import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/EventTicker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/common/newCommonComponent/GlobalFooterNewUi.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/newCommonComponent/GlobalHeaderNewUi.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/forms/EnqueryForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/CommonSection/NewInactivityPopup.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/new-home/AiLabs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/new-home/AiReadiness.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/new-home/AppliedAi.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/newPageComponent/new-home/Banner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/new-home/CpaCmaAlumni.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/new-home/OperatingModel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/newPageComponent/new-home/PartnershipMncs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
